import React from "react";
import { useTheme } from "@mui/material/styles";

export default ({ color, ...rest }) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }

  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 32 32"
      xmlSpace="preserve"
      {...rest}
    >
      <g>
        <path
          fill={color}
          d="M20.69,3v21.3H6.22V3H20.69 M21.69,0H5.22c-1.1,0-2,0.9-2,2v23.3c0,1.1,0.9,2,2,2h16.47c1.1,0,2-0.9,2-2V2
		C23.69,0.9,22.8,0,21.69,0L21.69,0z"
        />
      </g>
      <path
        fill={color}
        d="M13.45,12.7c1.42,0,2.56-1.14,2.56-2.56s-1.14-2.56-2.56-2.56s-2.56,1.14-2.56,2.56S12.04,12.7,13.45,12.7z"
      />
      <path
        fill={color}
        d="M13.45,13.55c-1.57,0-3.04,0.43-4.29,1.17c-0.52,0.3-0.83,0.87-0.83,1.47v5.36h10.24v-5.36
	c0-0.6-0.31-1.16-0.83-1.47C16.49,13.98,15.02,13.55,13.45,13.55z"
      />
      <g>
        <path
          fill={color}
          d="M25.37,32H8.31v-2.56h17.06c0.23,0,0.43-0.19,0.43-0.43V5.13h2.56v23.89C28.35,30.66,27.01,32,25.37,32z"
        />
      </g>
    </svg>
  );
};
